import { IStockCard } from './IStockCard'

export interface IPremix {
  [key: string]: string | boolean | number | null | IPremixIngredient[] | IPremixPremix[] | undefined
  premixId: string
  premixName: string
  stock: number | null
  premixIngredients: IPremixIngredient[]
  premixPremixes: IPremixPremix[]
  active: boolean
  department?: string
}

export class Premix {
  [key: string]: string | boolean | number | null | IPremixIngredient[] | IPremixPremix[] | undefined
  premixId: string
  premixName: string
  stock: number | null
  premixIngredients: IPremixIngredient[]
  premixPremixes: IPremixPremix[]
  active: boolean
  department?: string

  constructor({
    premixId,
    premixName,
    stock,
    active,
    premixIngredients,
    premixPremixes,
    department,
  }: Partial<IPremix> = {}) {
    this.premixId = premixId || ''
    this.premixName = premixName || ''
    this.department = department || 'KOSMETIK'
    this.stock = stock ?? 0
    this.active = active || false
    this.premixIngredients = premixIngredients || []
    this.premixPremixes = premixPremixes || []
  }
}

export interface IPremixIngredient {
  premixIngredientId: string
  premixId: string
  ingredientId: string
  ingredientName: string
  unit: string
  amount: number | string
  stock: number
}

export class PremixIngredient {
  premixIngredientId: string
  premixId: string
  ingredientId: string
  ingredientName: string
  unit: string
  amount: number | string
  stock: number

  constructor({
    premixIngredientId,
    premixId,
    ingredientId,
    ingredientName,
    unit,
    amount,
    stock,
  }: Partial<IPremixIngredient>) {
    this.premixIngredientId = premixIngredientId || ''
    this.premixId = premixId || ''
    this.ingredientId = ingredientId || ''
    this.ingredientName = ingredientName || ''
    this.unit = unit || 'KG'
    this.amount = amount || 0
    this.stock = stock || 0
  }
}

export interface IPremixPremix {
  premixPremixId: string | number
  parentPremixId: string
  childPremixId: string
  childPremixName: string
  amount: number | string
  stock: number
}

export class PremixPremix {
  premixPremixId: string | number
  parentPremixId: string
  childPremixId: string
  childPremixName: string
  amount: number | string
  stock: number

  constructor({
    premixPremixId,
    parentPremixId,
    childPremixId,
    childPremixName,
    amount,
    stock,
  }: Partial<IPremixPremix>) {
    this.premixPremixId = premixPremixId || ''
    this.parentPremixId = parentPremixId || ''
    this.childPremixId = childPremixId || ''
    this.childPremixName = childPremixName || ''
    this.amount = amount || 0
    this.stock = stock || 0
  }
}

export interface IBatch {
  [key: string]: string | boolean | Date | number | null | IStockCard[] | undefined | any[]
  batchNumber: string
  productionId: number | null
  productionDisplayId: string
  premixId: string
  premixName: string
  currentQuantity: number | string | null
  producedQuantity: number | string | null
  batchSize: number | string | null
  expiryDate: Date | string | null
  productionDate: Date | string | null
  lastModifiedEmployeeId: string
  createdAt: string
  createdBy: string
  stockCards: IStockCard[]
  qtyRequested?: string | number
  reworkIngredients?: {
    ingredientId: string
    ingredientName: string
    quantity: number
    stock: number
  }[]
  reworkPremixes?: {
    premixId: string
    premixName: string
    batchNumber: string
    quantity: number
    stock: number
  }[]
  nestedPremixBatches?: {
    childPremixId: string
    batchNumber: string
    quantity: number
  }[]
  isVirtual?: number
}
export class Batch {
  [key: string]: string | boolean | Date | number | null | IStockCard[] | undefined | any[]
  batchNumber: string
  productionId: number | null
  productionDisplayId: string
  premixId: string
  premixName: string
  currentQuantity: number | string | null
  producedQuantity: number | string | null
  batchSize: number | string | null
  expiryDate: Date | string | null
  productionDate: Date | string | null
  lastModifiedEmployeeId: string
  createdAt: string
  createdBy: string
  stockCards: IStockCard[]
  qtyRequested?: string | number
  isVirtual?: number

  reworkIngredients?: {
    ingredientId: string
    ingredientName: string
    quantity: number
    stock: number
  }[]
  reworkPremixes?: {
    premixId: string
    premixName: string
    batchNumber: string
    quantity: number
    stock: number
  }[]
  nestedPremixBatches?: {
    childPremixId: string
    batchNumber: string
    quantity: number
  }[]

  constructor({
    batchNumber,
    productionId,
    productionDisplayId,
    premixId,
    premixName,
    currentQuantity,
    producedQuantity,
    batchSize,
    expiryDate,
    productionDate,
    lastModifiedEmployeeId,
    createdAt,
    createdBy,
    stockCards,
    reworkIngredients,
    reworkPremixes,
    nestedPremixBatches,
    qtyRequested,
    isVirtual,
  }: Partial<IBatch>) {
    this.batchNumber = batchNumber || ''
    this.productionId = productionId ?? null
    this.productionDisplayId = productionDisplayId || ''
    this.premixId = premixId || ''
    this.premixName = premixName || ''
    this.currentQuantity = currentQuantity ?? null
    this.producedQuantity = producedQuantity ?? null
    this.batchSize = batchSize ?? null
    this.expiryDate = expiryDate || null
    this.productionDate = productionDate || null
    this.lastModifiedEmployeeId = lastModifiedEmployeeId || ''
    this.createdAt = createdAt || ''
    this.createdBy = createdBy || ''
    this.stockCards = stockCards || []
    this.reworkIngredients = reworkIngredients || []
    this.reworkPremixes = reworkPremixes || []
    this.nestedPremixBatches = nestedPremixBatches || []
    this.qtyRequested = qtyRequested
    this.isVirtual = isVirtual ?? 0
  }
}
